import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
	import ComputedGrid from '@/HostApp/ui/components/layout/ComputedGrid.vue';
	import ComputedGridItem from '@/HostApp/ui/components/layout/ComputedGridItem.vue';
	import systemLayoutModule, { useComputedStyle } from '@/HostApp/services/SystemLayout/SystemLayoutModule';

	
	const __default__ = {
		name: 'ComputedLayout',
		inheritAttrs: false
	};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		grid: {
			type: Object as PropType<LAYOUT.IGrid>,
			required: true
		},
		items: {
			type: Object as PropType<LAYOUT.IGridItem[]>,
			required: true
		},
		useAddons: {
			type: Boolean as PropType<boolean>,
			default: false
		}
	},
  setup(__props) {

const props = __props

	

	const computedGrid = computed(() => props.grid);

	const addons = computed(() => {
		return props.useAddons ? Object.values(systemLayoutModule.addons) : [];
	});

	const gridItems = computed(() => {
		const templateAreas = useComputedStyle(props.grid);
		const areas = templateAreas.value.gridTemplateAreas?.split("'").filter(Boolean) || [];

		const uniqAreas = areas.reduce((acc, curr) => {
			curr.split(' ').forEach((item) => item && acc.add(item));

			return acc;
		}, new Set());

		return (props.items || []).filter((item) => uniqAreas.has(item.name));
	});

	const allItems = computed(() => {
		return [...gridItems.value, ...addons.value];
	});

	const computedItems = computed(() => {
		return allItems.value.filter((item) => item.name !== 'viewport');
	});

	const viewport = computed(() => {
		const [item] = allItems.value.filter((item) => item.name === 'viewport');

		return item;
	});

	const hasViewport = computed(() => !!viewport.value);

return { __sfc: true,props, computedGrid, addons, gridItems, allItems, computedItems, viewport, hasViewport, ComputedGrid, ComputedGridItem }
}

})